export const HISTORY_FAMILY_CONSTANTS = {
  heading: 'Antecedentes Familiares',
  tooltip: 'Al marcar el antecedente que deseas describir, debes llenar el campo presentado. Y una vez que ya se encuentre grabado ya no lo puedes eliminar.',
  showDetail: 'Describir detalles',
  detailDescription: 'Selecciona el antecente que deseas describir y luego ingresa la información en el campo de texto',
  disclaimer: 'Recuerda que si ingresaste información adicional por grupo lo vas a poder visualizar al momento de dar click en el botón. Adicionalmente, la información detallada por grupo se va a visualizar en la generación de la história médica.'
};
